'use client';

import { usePreventScroll } from '@react-aria/overlays';
import { motion } from 'framer-motion';
import type { ComponentType } from 'react';

import type { IconProps } from '@zoomit/icons';
import { AnimatedThreeDots, cn, Flex } from '@zoomit/primitives';
import { cssVar, theme } from '@zoomit/zoomit-ds';

import styles from './global-loading.module.scss';

const animationVariants = {
  open: {
    opacity: 1,
  },
  close: {
    opacity: 0,
  },
};

type Props = {
  Logo: ComponentType<IconProps>;
};

const GlobalLoading = ({ Logo }: Props) => {
  usePreventScroll();

  return (
    <motion.div
      className="fixed top-0 right-0 bottom-0 left-0 z-[999] grid place-content-center bg-[rgba(25,25,35,0.8)]"
      initial="close"
      animate="open"
      exit="close"
      variants={animationVariants}
      data-testid="global-loading"
    >
      <Flex
        spacing={{ pt: 'x3' }}
        alignItems="center"
        justifyContent="center"
        className={cn(styles.root, 'bg-background1 h-[150px] w-[250px] rounded-[4px]')}
        flexDirection="column"
        gap={0.6}
      >
        <Logo width={148} height={30} fill={cssVar(theme.text)} />
        <AnimatedThreeDots />
      </Flex>
    </motion.div>
  );
};

export default GlobalLoading;
